import styled from 'styled-components';

export const StyledFuzzySearchHighlight = styled.span`
    background: yellow;
`;

